/* Femily drawer cart controller: serializes native line-item updates without polling. */
(function () {
  'use strict';

  if (window.__femilyCartController) return;
  window.__femilyCartController = true;

  var jobs = Object.create(null);

  function cartRequest(url, options) {
    return fetch(url, Object.assign({ credentials: 'same-origin' }, options || {}))
      .then(function (response) {
        if (!response.ok) throw new Error('cart-request');
        return response.json();
      });
  }

  function propertiesKey(properties) {
    return JSON.stringify(properties || {});
  }

  function getLine(cart, state) {
    var exact = (cart.items || []).find(function (item) { return item.key === state.originalKey; });
    if (exact && !state.identity) {
      state.identity = { variantId: exact.variant_id, properties: propertiesKey(exact.properties) };
      return exact;
    }
    if (!state.identity) return exact;
    return (cart.items || []).find(function (item) {
      return item.variant_id === state.identity.variantId && propertiesKey(item.properties) === state.identity.properties;
    });
  }

  function renderCartDrawer() {
    if (window.T4SThemeSP && window.T4SThemeSP.Cart && typeof window.T4SThemeSP.Cart.getToFetch === 'function') {
      window.T4SThemeSP.Cart.getToFetch(true);
    } else {
      document.dispatchEvent(new CustomEvent('cart:refresh:opend'));
    }
  }

  function notice(message) {
    if (window.T4SThemeSP && typeof window.T4SThemeSP.Notices === 'function') window.T4SThemeSP.Notices(message);
  }

  function finishJob(state) {
    state.running = false;
    delete jobs[state.originalKey];
  }

  function runJob(state) {
    if (state.running) return;
    state.running = true;

    (async function () {
      try {
        while (state.nextQuantity !== null) {
          var requestedQuantity = state.nextQuantity;
          state.nextQuantity = null;

          var cart = await cartRequest('/cart.js', { cache: 'no-store' });
          var line = getLine(cart, state);
          if (!line) {
            renderCartDrawer();
            break;
          }
          if (Number(line.quantity) === requestedQuantity) continue;

          await cartRequest('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: line.key, quantity: requestedQuantity })
          });

          renderCartDrawer();
        }
      } catch (error) {
        renderCartDrawer();
        notice('Não foi possível atualizar este item. Tente novamente.');
      } finally {
        finishJob(state);
      }
    })();
  }

  function queueChange(element, quantity) {
    var originalKey = element.getAttribute('data-id');
    if (!originalKey) return;
    var state = jobs[originalKey];
    if (!state) {
      state = jobs[originalKey] = {
        originalKey: originalKey,
        identity: null,
        nextQuantity: null,
        running: false
      };
    }
    state.nextQuantity = Math.max(0, Number(quantity) || 0);
    runJob(state);
  }

  var nativeBindAttempts = 0;
  var nativeBindTimer = null;
  function bindNativeCartController() {
    if (!window.jQuery_T4NT || !window.T4SThemeSP || !window.T4SThemeSP.ProductAjax) {
      if (!nativeBindTimer && nativeBindAttempts++ < 100) {
        nativeBindTimer = setTimeout(function () { nativeBindTimer = null; bindNativeCartController(); }, 80);
      }
      return;
    }

    nativeBindAttempts = 0;
    var $ = window.jQuery_T4NT;
    var controller = function () {
      var container = $('[data-cart-items]');
      container.off('change', '[data-action-change]').on('change.femilyCartController', '[data-action-change]', function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        queueChange(this, this.value || 0);
      });
      container.off('click.remove', '[data-cart-remove]').off('click.femilyCartController', '[data-cart-remove]').on('click.femilyCartController', '[data-cart-remove]', function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        queueChange(this, 0);
      });
    };

    /* The theme replaces drawer markup after every cart response. Rebind only
       after its renderer is done, so the native stale-key listener never returns. */
    window.T4SThemeSP.ProductAjax.change = controller;
    if (!window.__femilyCartRenderWrapped && window.T4SThemeSP.Cart && typeof window.T4SThemeSP.Cart.renderContents === 'function') {
      window.__femilyCartRenderWrapped = true;
      var nativeRenderContents = window.T4SThemeSP.Cart.renderContents;
      window.T4SThemeSP.Cart.renderContents = function () {
        var output = nativeRenderContents.apply(this, arguments);
        setTimeout(controller, 0);
        return output;
      };
    }
    controller();
  }

  function normalizeCep(value) {
    return String(value || '').replace(/\D/g, '').slice(0, 8);
  }

  function maskCep(value) {
    var digits = normalizeCep(value);
    return digits.length > 5 ? digits.slice(0, 5) + '-' + digits.slice(5) : digits;
  }

  function setCepMessage(message, isError) {
    var node = document.getElementById('femily-drawer-cep-message');
    if (!node) return;
    node.textContent = message || '';
    node.classList.toggle('is-error', Boolean(isError));
    node.classList.toggle('is-success', Boolean(message) && !isError);
  }

  function cepRequest(url) {
    return fetch(url, { headers: { Accept: 'application/json' } }).then(function (response) {
      if (!response.ok) throw new Error('cep');
      return response.json();
    });
  }

  document.addEventListener('input', function (event) {
    if (event.target && event.target.id === 'femily-drawer-cep') event.target.value = maskCep(event.target.value);
  });

  document.addEventListener('keydown', function (event) {
    if (event.target && event.target.id === 'femily-drawer-cep' && event.key === 'Enter') {
      event.preventDefault();
      var button = document.getElementById('femily-drawer-cep-button');
      if (button) button.click();
    }
  });

  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest && event.target.closest('#femily-drawer-cep-button');
    if (!button) return;
    var input = document.getElementById('femily-drawer-cep');
    if (!input) return;
    var cep = normalizeCep(input.value);
    input.value = maskCep(cep);
    setCepMessage('');

    if (cep.length !== 8) {
      setCepMessage('Informe um CEP válido com 8 dígitos.', true);
      input.focus();
      return;
    }

    button.disabled = true;
    button.textContent = 'CONSULTANDO';
    cepRequest('https://brasilapi.com.br/api/cep/v2/' + cep)
      .then(function (data) { return data.city || data.localidade || null; })
      .catch(function () {
        return cepRequest('https://viacep.com.br/ws/' + cep + '/json/').then(function (data) {
          if (data.erro) throw new Error('cep');
          return data.localidade || null;
        });
      })
      .then(function (city) {
        if (!city) throw new Error('cep');
        setCepMessage('CEP localizado. Confira o valor e o prazo de entrega no checkout.');
      })
      .catch(function () { setCepMessage('Não foi possível consultar este CEP agora. Tente novamente.', true); })
      .finally(function () {
        button.disabled = false;
        button.textContent = 'CALCULAR';
      });
  });

  var lifecycleBindAttempts = 0;
  function bindLifecycleEvents() {
    if (!window.jQuery_T4NT) {
      if (lifecycleBindAttempts++ < 100) setTimeout(bindLifecycleEvents, 80);
      return;
    }
    window.jQuery_T4NT(document)
      .off('cart:updated.femilyCartController')
      .on('cart:updated.femilyCartController', function () {
        /* The theme restores its native handler while re-rendering sections.
           Reinstall immediately after that official lifecycle event. */
        setTimeout(bindNativeCartController, 0);
      });
  }

  function boot() {
    bindNativeCartController();
    bindLifecycleEvents();
    /* Main theme assets may initialize after this deferred asset. Rebind once
       after load, then on every official cart render above. */
    window.addEventListener('load', function () {
      setTimeout(bindNativeCartController, 120);
    }, { once: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();